/* curatedKinaseCases.js -- GENERATED, do not edit by hand.
 *
 * The curated kinase cases that have fragment data, partitioned by DFG
 * conformation. Each entry is a MapCase projectCase ("project/case"),
 * which equals the structureKey for the kinase-library case.
 *
 * Source of truth: tools/kinase-prep/curated-cases/*.txt
 * Regenerate with: python tools/kinase-prep/gen-curated-cases.py
 */

// DFG-in: 283 curated case(s) with fragment data.
export const DFG_IN_CASES = [
    'AAK1/4WSQ_altA',
    'ABL1/2GQG_altA',
    'ABL2/2XYN_altA',
    'ACK/4HZR_altA',
    'ACTR2/3Q4T_altA',
    'ACTR2B/2QLU',
    'ADCK3/7UDP',
    'AKT1/3CQU_altA',
    'AKT2/3E87_altA',
    'ALK/2YJR_altA',
    'ALK1/3MY0',
    'ALK2/3MTF_altA',
    'AMPKa1/4RED',
    'AMPKa2/4ZHX_altA',
    'ANKRD3/5WNI',
    'ATM/5NP0',
    'ATR/5YZ0',
    'AXL/5U6B',
    'AurA/2X6D_altA',
    'AurC/6GR8_altA',
    'BARK1/3V5W_altA',
    'BIKE/4W9W_altA',
    'BMPR1B/3MDY_altA',
    'BRAF/4H58_altA',
    'BRK/5DA3_altA',
    'BRSK2/4YNZ',
    'BTK/3GEN_altA',
    'BUB1/6F7B_altA',
    'CASK/3C0G_altA',
    'CDC2/4Y72_altA',
    'CDC7/6YA7_altA',
    'CDK2/1CKP_altA',
    'CDK4/3G33',
    'CDK5/4AU8_altA',
    'CDK6/1BLX',
    'CDK7/8P4Z_altA',
    'CDK8/4F7S_altA',
    'CDK9/4IMY_altA',
    'CDKL1/4AGU',
    'CDKL2/4AAA_altA',
    'CDKL3/3ZDU',
    'CDKL5/4BGQ_altA',
    'CHED/7NXJ',
    'CHK1/2BR1_altA',
    'CHK2/2W7X_altA',
    'CK1a/5FQD_C',
    'CK1d/4KB8_altA',
    'CK1e/4HOK',
    'CK1g2/2C47_altA',
    'CK1g3/2CHL_altA',
    'CK2a1/3AT2_altA',
    'CK2a2/5M4U_altA',
    'CLK1/1Z57_altA',
    'CLK2/6FYK_altA',
    'CLK3/2EU9_altA',
    'CLK4/6FYV_altA',
    'COT/5IU2_altA',
    'CRK7/8P81_altA',
    'CSK/3D7T',
    'CaMK1a/4FG7',
    'CaMK1d/6QP5_altA',
    'CaMK1g/2JAM_altA',
    'CaMK2a/2VZ6_altA',
    'CaMK2b/3BHH',
    'CaMK2d/2WEL_altA',
    'CaMK2g/2V7O_altA',
    'CaMK4/2W4O',
    'CaMKK2/5UYJ_altA',
    'DAPK1/1JKS_altA',
    'DAPK2/2A2A_altA',
    'DAPK3/2J90_altA',
    'DCLK1/6KYQ_altA',
    'DLK/5CEN_altA',
    'DMPK1/2VD5',
    'DNAPK/7K0Y_altA',
    'DRAK1/7QUE',
    'DRAK2/3LM0_altA',
    'DYRK1A/2VX3_altA',
    'DYRK1B/8C2Z_altA',
    'DYRK2/3KVW_altA',
    'DYRK3/5Y86',
    'EGFR/1M17_altA',
    'EphA2/5I9U_altA',
    'EphA3/2QO2_altA',
    'EphA4/2Y6M_altA',
    'EphA5/2R2P_altA',
    'EphA7/2REI_altA',
    'EphA8/3KUL_altA',
    'EphB1/6UMW_altA',
    'EphB2/1JPA',
    'EphB4/2VWV_altA',
    'ErbB2/3PP0_altA',
    'ErbB3/6OP9_altA',
    'ErbB4/2R4B_altA',
    'Erk1/4QTB_altA',
    'Erk2/4IZ7_altA',
    'Erk3/7AQB_altA',
    'Erk5/4ZSG_altA',
    'FAK/2IJM_altA',
    'FES/3BKB_altA',
    'FGFR1/1AGW_altA',
    'FGFR2/4J96_altA',
    'FGFR3/6LVM',
    'FGFR4/4TYG_altA',
    'FGR/7UY0_altA',
    'FMS/3LCD_altA',
    'FRAP/4JSN',
    'FYN/2DQ7_X',
    'GAK/4C57_altA',
    'GCN2/8T7T_altA',
    'GPRK5/6PJX_altA',
    'GPRK6/3NYN',
    'GSK3A/7SXF_altA',
    'GSK3B/1R0E_altA',
    'HCK/2C0I_altA',
    'HGK/4OBO_altA',
    'HH498/4YFF_altA',
    'HIPK2/6P5S_altA',
    'HIPK3/7O7I',
    'HPK1/6NFY_altA',
    'Haspin/2WB8_altA',
    'IGF1R/3D94_altA',
    'IKKb/4KIK_altA',
    'INSR/3EKK_altA',
    'IRAK1/6BFN_altA',
    'IRAK3/6RUU',
    'IRAK4/2NRU_altA',
    'IRE1/4YZC_altA',
    'IRR/7TYK',
    'ITK/3QGW_altA',
    'JAK1/3EYG_altA',
    'JAK1-b/4L00_altA',
    'JAK2/2XA4_altA',
    'JAK2-b/5I4N_altA',
    'JAK3/1YVJ_altA',
    'JNK1/3ELJ_altA',
    'JNK2/7CML_altA',
    'JNK3/2OK1_altA',
    'KDR/3CJG_altA',
    'KHS2/5J5T',
    'KIT/8PQ9_altA',
    'KSR2/2Y4I_B',
    'LCK/3LCK_altA',
    'LIMK1/3S95_altA',
    'LIMK2/8WSW_altA',
    'LOK/2J7T_altA',
    'LRRK1/8FAC',
    'LRRK2/8TZC',
    'LYN/2ZV7',
    'MAP2K1/3DV3_altA',
    'MAP2K2/1S9I',
    'MAP2K7/6YG1_altA',
    'MAP3K5/3VW6_altA',
    'MAPKAPK2/3KGA_altA',
    'MAPKAPK3/3FHR_altA',
    'MARK1/2HAK_B',
    'MARK2/3IEC',
    'MARK3/3FE3_altA',
    'MARK4/5ES1',
    'MASTL/5LOH_altA',
    'MELK/4BKZ_altA',
    'MER/3BPR_altA',
    'MET/2WD1_altA',
    'MLK1/4UY9_altA',
    'MLKL/4M68_altA',
    'MNK2/2AC5_altA',
    'MPSK1/2BUJ',
    'MRCKb/4UAK_altA',
    'MSK1/1VZO_altA',
    'MSK1-b/3KN6',
    'MST1/8A5J_altA',
    'MST2/4LG4_altA',
    'MST3/4QMN_altA',
    'MST4/7B36',
    'MYT1/3P1A_altA',
    'NEK2/2W5A_altA',
    'NEK7/2WQM_altA',
    'NIK/4G3C_altA',
    'PAK1/4EQC_altA',
    'PAK4/2CDZ_altA',
    'PAK5/2F57_altA',
    'PAK6/2C30_altA',
    'PASK/3DLS',
    'PBK/5J0A',
    'PDGFRa/8PQI_altA',
    'PDK1/1H1W_altA',
    'PEK/4G34_altA',
    'PHKg1/8XYB_C',
    'PHKg2/2Y7J_altA',
    'PI4K2A/4HNE',
    'PI4KB/4D0L',
    'PIK3C3/3LS8_altA',
    'PIK3R4/8SOR_D',
    'PIM1/1XWS_altA',
    'PIM2/4X7Q',
    'PKACa/3NX8_altA',
    'PKCa/8U37_altA',
    'PKCb/2I0E',
    'PKCh/8FP3_altA',
    'PKCi/4DC2_altA',
    'PKCt/4Q9Z_altA',
    'PKG1/6BDL_altA',
    'PKN1/4OTG_altA',
    'PKR/3UIU',
    'PLK1/2OWB_altA',
    'PLK2/4I5P_altA',
    'PLK3/4B6L',
    'PLK4/4JXF',
    'PRP4/4IFC_altA',
    'PRPK/7SZA_altA',
    'PYK2/3CC6_altA',
    'Pik3c2a/7BI2_altA',
    'QSK/8OKU',
    'RAF1/3OMV',
    'RET/2IVS_altA',
    'RIOK1/6ZXD_z',
    'RIOK2/6FDN',
    'RIPK2/5AR2_altA',
    'RIPK3/4M66_altA',
    'ROCK1/5WNF_altA',
    'ROCK2/6P5M_altA',
    'ROS/3ZBF',
    'RSK1-b/8WF4',
    'RSK2/4NW5_altA',
    'RSK2-b/2QR7_altA',
    'RSK3/2Z7Q',
    'RSK3-b/2WNT_altA',
    'RYK/6TUA',
    'SGK1/3HDM',
    'SLK/2UV2_altA',
    'SMG1/6L53',
    'SNRK/5YKS',
    'SRC/2H8H_altA',
    'SRPK1/4WUA_altA',
    'SRPK2/5MYV_altA',
    'STLK3/5D9H',
    'STLK5/3GNI_B',
    'SYK/1XBB_altA',
    'SgK085/2X4F_altA',
    'SgK269/6BHC_altA',
    'SgK495/5L2Q_B_altA',
    'TAK1/2EVA_altA',
    'TAO3/6BDN_altA',
    'TBK1/4EUT_altA',
    'TGFbR1/2WOT_altA',
    'TGFbR2/5E8V_altA',
    'TIE2/3L8P',
    'TNIK/2X7F_altA',
    'TRKA/4AOJ_altA',
    'TRKB/4AT3',
    'TTBK1/4NFN_altA',
    'TTBK2/6U0K_altA',
    'TTK/3H9F_altA',
    'TTN/4JNW_altA',
    'TYK2/3NYX_altA',
    'TYK2-b/4WOV_altA',
    'TYRO3/4FEQ',
    'Trb1/6DC0_altA',
    'Trb2/7UPM',
    'ULK1/4WNO_altA',
    'ULK2/6QAU_altA',
    'ULK3/6FDY_U',
    'ULK4/6U5L_altA',
    'VRK1/3OP5_altA',
    'VRK2/2V62_altA',
    'VRK3/2JII_altA',
    'Wee1/3BI6_altA',
    'Wee1B/5VDK',
    'Wnk1/4PWN',
    'Wnk3/5O1V_altA',
    'YANK1/4FR4_altA',
    'YSK1/2XIK_altA',
    'ZAK/5HES_altA',
    'ZAP70/1U59_altA',
    'p110a/4JPS_altA',
    'p110b/4BFR',
    'p110d/2WXF_altA',
    'p110g/3L08_altA',
    'p38a/1OVE_altA',
    'p38b/3GC8',
    'p38d/3COI_altA',
    'p38g/6UNA_altA',
    'p70S6K/3WF5_altA',
];

// DFG-out: 94 curated case(s) with fragment data.
export const DFG_OUT_CASES = [
    'ABL1/2HZ0_altA',
    'ABL2/3GVU_altA',
    'ACK/5ZXB_altA',
    'AKT1/7NH5_altA',
    'AKT2/8Q61_altA',
    'ALK/5IUG_altA',
    'AMPKa2/2H6D_altA',
    'AurA/1MUO',
    'BRAF/4XV9_altA',
    'BRK/6CZ4_altA',
    'CCK4/6VG3',
    'CDK2/5A14_altA',
    'CDK6/1BI7',
    'CDK7/8BVW_I',
    'CDK8/3RGF_altA',
    'CK1e/4HNI',
    'CaMK2a/7B55_altA',
    'CaMKK1/6CD6_altA',
    'DDR1/3ZOS_altA',
    'DDR2/7AYM_altA',
    'EGFR/4ZJV_altA',
    'EphA2/5IA4_altA',
    'EphA3/3DZQ_altA',
    'EphA7/3DKO_altA',
    'EphB4/6FNI_altA',
    'ErbB3/7MN5',
    'FAK/4EBW_altA',
    'FGFR1/4V01_altA',
    'FGFR4/4QRC',
    'FGR/7UY3',
    'FLT1/3HNG_altA',
    'FLT3/4RT7_altA',
    'FMS/3DPK_altA',
    'GCN2/6N3L_altA',
    'HGK/4OBO_B_altA',
    'HH498/7MGK_altA',
    'HPK1/8PAS',
    'HSER/8FX4_D',
    'IGF1R/3LW0_altA',
    'INSR/3ETA_altA',
    'IRAK4/6EG9_altA',
    'IRE1/6HX1_altA',
    'JAK2/3UGC_altA',
    'JNK2/3NPC',
    'KDR/2OH4_altA',
    'KIT/1T45_altA',
    'LCK/6PDJ_altA',
    'LIMK1/7ATU',
    'LIMK2/5NXD_altA',
    'LKB1/8VSU_B',
    'LMR3/6SEQ_altA',
    'LOK/4EQU_altA',
    'LRRK1/8E04',
    'LRRK2/8TXZ_altA',
    'MELK/5K00_altA',
    'MER/7AAX_altA',
    'MET/3CTJ_altA',
    'MLKL/6O5Z_B',
    'MNK1/2HW6',
    'MNK2/2AC3',
    'NEK2/2JAV_altA',
    'NEK7/5DE2_altA',
    'PAK1/4ZJI_altA',
    'PCTAIRE1/5G6V',
    'PDGFRa/5GRN_altA',
    'PDK1/3QC4_altA',
    'PEK/4X7H_altA',
    'PHKg1/8JFL_B',
    'PRP4/6CNH_altA',
    'PYK2/3FZS',
    'RAF1/8GAE_D',
    'RIPK1/4ITH_altA',
    'RIPK2/5AR7_altA',
    'RIPK3/6OKO_altA',
    'ROCK1/3TWJ_B',
    'ROCK2/8GDS',
    'ROR1/6TU9',
    'ROR2/3ZZW_B_altA',
    'SGK196/5GZ8',
    'SLK/8BEM_altA',
    'SRC/7OTE',
    'SYK/3TUB',
    'SgK223/5VE6',
    'TAK1/2YIY',
    'TIE2/6MWE_altA',
    'TRKA/4GT5_altA',
    'TRKB/4ASZ',
    'TRKC/4YMJ_altA',
    'TRRAP/8H7G',
    'ULK3/6FDZ_U',
    'p38a/2EWA_altA',
    'p38b/3GP0_altA',
    'p38d/4EYJ',
    'p70S6K/3A60_B',
];

// DFG-out-like (not in the DFG-in or DFG-out lists): 34 curated case(s) with fragment data.
export const DFG_OUTLIKE_CASES = [
    'ATM/6K9K',
    'AurB/4AF3',
    'BMX/3SXR',
    'BTK/3OCT_altA',
    'BUBR1/6TLJ_S',
    'CDK4/5FWM_K',
    'CSK/1BYG',
    'CaMK1a/4FG8',
    'EphB3/3ZFY_altA',
    'Erk3/6YKY_altA',
    'GAK/4C58_altA',
    'HCK/3VS1',
    'ILK/3KMW',
    'IRAK3/6RUU_C',
    'JNK3/3OXI',
    'MAP2K4/3VUT',
    'MAP2K6/3ENM_altA',
    'MAP2K7/5B2L_altA',
    'MAP3K5/2CLQ_altA',
    'MARK1/2HAK',
    'MST3/3CKW_altA',
    'MST4/3GGF_altA',
    'NEK1/4APC_altA',
    'PI4K2B/8A5X',
    'PIK3R4/7BL1_C',
    'RSK2/3UBD_altA',
    'STLK5/8VSU_C',
    'SgK495/5L2Q_altA',
    'TNIK/8X88',
    'TYRO3/3QUP',
    'Trb1/5CEM_altA',
    'VRK1/2KTY_alt10',
    'YSK1/4NZW_B',
    'p110a/5SXE',
];
